export const EMERGENCY_REVENUE_CODE = '1001';

export const EXTENSION_PATIENT_PAID = 'http://fhir-api.zapehr.com/extension/patient-paid';
export const EXTENSION_PATIENT_ACCOUNT_NUMBER = 'http://fhir-api.zapehr.com/extension/patient-account-number';
export const EXTENSION_PATIENT_SIGNED_DATE = 'http://fhir-api.zapehr.com/extension/patient-signed-date';
export const EXTENSION_PRACTITIONER_SIGNED_DATE = 'http://fhir-api.zapehr.com/extension/practitioner-signed-date';
export const EXTENSION_CLAIM_CONDITION_CODE = 'http://fhir-api.zapehr.com/extension/claim-condition-code';
export const EXTENSION_OUTSIDE_CHARGES = 'http://fhir-api.zapehr.com/extension/outside-charges';
export const RAW_RESPONSE = 'http://fhir-api.zapehr.com/extension/raw-response';

export const CODE_SYSTEM_CLAIM_TYPE = 'http://terminology.hl7.org/CodeSystem/claim-type';
export const CODE_SYSTEM_PROCESS_PRIORITY = 'http://terminology.hl7.org/CodeSystem/processpriority';
export const CODE_SYSTEM_CLAIM_INFORMATION_CATEGORY = 'http://terminology.hl7.org/CodeSystem/claiminformationcategory';
export const CODE_SYSTEM_ACT_CODE_V3 = 'http://terminology.hl7.org/CodeSystem/v3-ActCode';
export const CODE_SYSTEM_ICD_9 = 'http://hl7.org/fhir/sid/icd-9-cm';
export const CODE_SYSTEM_ICD_10 = 'http://hl7.org/fhir/sid/icd-10-cm';
export const CODE_SYSTEM_CPT = 'http://www.ama-assn.org/go/cpt';
export const CODE_SYSTEM_HCPCS = 'http://www.cms.gov/Medicare/Coding/HCPCSReleaseCodeSets';
export const CODE_SYSTEM_NDC = 'http://hl7.org/fhir/sid/ndc';
export const CODE_SYSTEM_CMS_PLACE_OF_SERVICE =
  'http://www.cms.gov/Medicare/Coding/place-of-service-codes/Place_of_Service_Code_Set.html';
export const CODE_SYSTEM_COVERAGE_CLASS = 'http://terminology.hl7.org/CodeSystem/coverage-class';
export const CODE_SYSTEM_PAYEE_TYPE = 'http://terminology.hl7.org/CodeSystem/payeetype';
export const CODE_SYSTEM_PROVIDER_TAXONOMY = 'http://nucc.org/provider-taxonomy';

export const CODE_SYSTEM_OYSTEHR_RCM_CMS1500_REFERRING_PROVIDER_TYPE =
  'https://terminology.zapehr.com/rcm/cms1500/referring-provider-type';
export const CODE_SYSTEM_OYSTEHR_RCM_CMS1500_DATE_TYPE = 'https://terminology.zapehr.com/rcm/cms1500/date-type';
export const CODE_SYSTEM_OYSTEHR_RCM_CMS1500_RESUBMISSION_RELATIONSHIP =
  'https://terminology.zapehr.com/rcm/cms1500/resubmission-relationship';
export const CODE_SYSTEM_OYSTEHR_RCM_CMS1500_PROCEDURE_MODIFIER =
  'https://terminology.zapehr.com/rcm/cms1500/procedure-modifier';
export const CODE_SYSTEM_OYSTEHR_RCM_CMS1500_REVENUE_CODE = 'https://terminology.zapehr.com/rcm/cms1500/revenue-code';

export const EXTENSION_URL_CPT_MODIFIER = 'https://fhir.ottehr.com/Extension/cpt-code-modifier';
export const CODE_SYSTEM_CPT_MODIFIER = 'https://fhir.ottehr.com/CodeSystem/cpt-code-modifier';
